import { c as _c } from "react/compiler-runtime";
import React from "react";
const NotificationSkeleton = t0 => {
  const $ = _c(2);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = <><div className="flex z-50 flex-wrap gap-2 sm:gap-4 w-full">{Array.from({
          length: count
        }).map(_temp)}</div></>;
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default NotificationSkeleton;
function _temp(_, index) {
  return <div key={index} role="status" className="w-full p-2 sm:p-3 space-y-4 border border-gray-100 divide-y divide-gray-100 my-1 rounded-lg animate-pulse dark:divide-gray-100 dark:border-gray-100"><div className="flex gap-2 sm:gap-3 items-center"><div className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-200 rounded-lg dark:bg-gray-200 flex-shrink-0" /><div className="flex-1 flex flex-col space-y-2"><div className="w-3/4 sm:w-80 h-2 bg-gray-200 rounded-full dark:bg-gray-200" /><div className="w-full sm:w-80 h-8 sm:h-10 bg-gray-200 rounded-md dark:bg-gray-200" /><div className="w-1/2 sm:w-40 h-2 bg-gray-200 rounded-full dark:bg-gray-200" /></div></div><span className="sr-only">Loading...</span></div>;
}